<template>
  <div class="d-flex flex-column align-center ga-1">
    <div v-for="activity in store.commentsList" :key="activity.id" class="single-overview">
      <div class="head d-flex justify-space-between align-center">
        <div class="icon-name d-flex ga-2 align-center">
          <div class="icon d-flex">
            <img :src="getIcon(activity.type)" alt="Note" width="24" />
          </div>
          <div class="name text-capitalize">{{ activity.type }}</div>
        </div>
        <div class="date text-capitalize">
          {{ activity.from }}
        </div>
      </div>
      <div class="body">
        <div class="body-card">
          <div class="card-head d-flex justify-space-between align-center mb-2">
            <div class="name-img d-flex align-center ga-2">
              <img class="circle-img" :src="activity?.user?.image" :alt="activity?.user?.name" />
              <div class="name d-flex flex-column">
                <span>{{ activity?.user?.name }}</span>
                <span class="small-text">{{ activity.created_at }}</span>
              </div>
            </div>
          </div>
          <div class="card-body" v-html="shortContent(activity.content)"></div>
          <v-divider class="my-2"></v-divider>
          <div class="card-footer d-flex justify-end" @click="openDialog(activity)">
            read more
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="text-h6 d-flex justify-space-between align-center">
          <div class="d-flex justify-space-between align-center">
            <img :src="getIcon(selectedActivity.type)" alt="Type Icon" width="30" height="30" class="mr-2" />
            <span class="text-capitalize">{{ selectedActivity?.type }}</span>
          </div>
          <v-btn icon @click="dialog = false" elevation="0">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="text-subtitle-2">
          {{ selectedActivity?.user?.name }} |
          {{ selectedActivity?.created_at }}
        </v-card-subtitle>
        <v-card-text class="pa-4">
          <div v-html="sanitizedContent(selectedActivity?.content)"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NoteIcon from "@/assets/images/icons/note.svg";
import CallSuIcon from "@/assets/images/icons/call-su.svg";
import MeetingIcon from "@/assets/images/icons/meeting.svg";
import DOMPurify from "dompurify";
import { useLeadsStore } from "@/store/crm/useLeadsStore";

export default {
  props: ["item", "selectedSortItem", "activities"],
  name: "OverviewContents",
  data() {
    return {
      store: useLeadsStore(),
      localSelectedSortItem: "Oldest",
      dialog: false,
      selectedActivity: null,
    };
  },
  watch: {
    selectedSortItem(newVal) {
      this.localSelectedSortItem = newVal;
    },
  },
  methods: {
    sanitizedContent(content) {
      return DOMPurify.sanitize(content);
    },
    shortContent(content) {
      const plainText = DOMPurify.sanitize(content, {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: [],
      });
      return plainText.length > 100
        ? plainText.substring(0, 100) + "..."
        : plainText;
    },
    openDialog(activity) {
      this.selectedActivity = activity;
      this.dialog = true;
    },
    getIcon(type) {
      return type === "Meeting"
        ? MeetingIcon
        : type === "Note"
          ? NoteIcon
          : CallSuIcon;
    },
  },
};
</script>

<style scoped>
.single-overview {
  width: 100%;
}

@media (min-width: 600px) {
  .single-overview {
    width: 80%;
  }
}

@media (min-width: 960px) {
  .single-overview {
    width: 60%;
  }
}

@media (min-width: 1264px) {
  .single-overview {
    width: 50%;
  }
}

/* Header Section */
.single-overview .name {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

.single-overview .date {
  font-size: 12px;
  font-weight: 400;
  line-height: 28px;
  color: #999999;
}

/* Body Section */
.single-overview .body {
  padding: 16px;
  border-left: solid #d3cfcf 1px;
  margin-left: 12px;
  margin-top: 10px;
}

.single-overview .body-card {
  padding: 6px 14px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #d6d6d6;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}

/* Footer */
.single-overview .card-footer {
  font-size: 14px;
  font-weight: 500;
  color: #237276;
  cursor: pointer;
  text-transform: capitalize;
}
</style>
